/* eslint-disable */
import { Link } from "react-router-dom";
import { SocialShare } from "../components/subcomponents/Sharesocial";
import { routes } from "../utils/utils.routes";
import { ContactLink } from "../components/subcomponents/ContactComponent";
import { Hrseparator } from "../components/subcomponents/Hrseparator";
import { BreadcrumpComponent } from "../components/subcomponents/BreadcrumpCompont";
import { PageSectionHeader } from "../components/subcomponents/PageSectionHeader";
import hero from "../assets/images/hero-image.png";
import Table, { ColumnsType } from "antd/es/table";
import { laureatsData } from "../utils/utils.statiquedata";
import { Colors } from "../utils/utils.colors";

const columns: ColumnsType<Laureat> = [
    {
        title: 'Numéro',
        dataIndex: 'numero',
        key: 'numero',
        sorter: (a, b) => a.numero - b.numero,
        width: 100,
        fixed: "left"
    },
    {
        title: 'Nom Complet',
        dataIndex: 'nom',
        key: 'nom',
        fixed: "left",
        width: 200,
        sorter: (a, b) => a.nom.localeCompare(b.nom),
    },
    {
        title: 'Pourcentage',
        dataIndex: 'pourcentage',
        key: 'pourcentage',
        sorter: (a, b) => a.pourcentage - b.pourcentage,
        className: "bg-primary",
        render: (pourcentage) => (
            <b style={{ color: Colors.whiteColor }}>{pourcentage}%</b>
        ),
        width: 130,
    },
    {
        title: 'Année',
        dataIndex: 'annee',
        key: 'annee',
        filters: [
            ...Object.keys(laureatsData.laureats).map(annee => ({ text: annee, value: annee }))
        ],
        onFilter: (value, record) => record?.annee?.toString() === value?.toString(),
        width: 120,
    },
    {
        title: 'Option / Section',
        dataIndex: 'option',
        key: 'option',
        filters: [
            { text: 'Bio-Chimie', value: 'Bio-Chimie' },
            { text: 'Pédagogie Générale', value: 'Pédagogie Générale' },
            { text: 'Latin-Philo', value: 'Latin-Philo' },
            { text: 'Commerciale et gestion', value: 'Commerciale et gestion' },
            { text: 'Commerciale et Administrative', value: 'Commerciale et Administrative' },
        ],
        onFilter: (value, record) => record.option === value,
    },
];

export const Aumonerie = () => {
    const allLaureats: Laureat[] = [
        ...Object.values(laureatsData.laureats).flat()
    ];

    return (
        <>
            <BreadcrumpComponent
                imageCover={hero}
                title="Aumônerie ULPGL"
                subtitle="Ancrée dans notre identité d'université chrétienne et protestante, l'aumônerie universitaire est le cœur spirituel de notre campus. Elle offre un espace d'écoute, d'accompagnement et de ressourcement pour toute la communauté estudiantine, favorisant ainsi l'épanouissement de la foi, le partage des valeurs évangéliques et la croissance personnelle de chacun."
            />

            <div className="container page-content">
                <div className="row">
                    <aside className="col-md-4 pe-md-5">
                        <SocialShare slug="aumonerie-universitaire" title="Aumônerie ULPGL" description="Ancrée dans notre identité d'université chrétienne et protestante, l'aumônerie universitaire est le cœur spirituel de notre campus." />

                        <div className="mt-5 pt-5">
                            <PageSectionHeader
                                eyebrow="Explorer"
                                title="Voir aussi"
                                size="compact"
                                align="start"
                            />
                            <ul className="list-unstyled detail-section__list">
                                <li className="mb-2">
                                    <Link to={routes.KAUTA} className="text-decoration-none text-dark">
                                        École primaire KAUTA
                                    </Link>
                                </li>
                                <li className="mb-2">
                                    <Link to={routes.METANOIA} className="text-decoration-none text-dark">
                                        Institut Metanoia
                                    </Link>
                                </li>
                                <li className="mb-2">
                                    <Link to={routes.KAUTA_MATERNEL} className="text-decoration-none text-dark">
                                        La Crèche
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </aside>

                    <main className="col-md-8">
                        <article className="entry-content detail-sections">
                            <section className="detail-section detail-section--first">
                                <PageSectionHeader
                                    eyebrow="Présentation"
                                    title="Profil et présentation"
                                    size="compact"
                                    align="start"
                                />
                                <p>
                                    Ancrée dans notre identité d'université chrétienne et protestante, l'aumônerie universitaire est le cœur spirituel de notre campus.
                                    Elle offre un espace d'écoute, d'accompagnement et de ressourcement pour toute la communauté estudiantine, favorisant ainsi l'épanouissement de la foi, le partage des valeurs évangéliques et la croissance personnelle de chacun.
                                </p>
                            </section>

                            {/* <section className="detail-section">
                                <PageSectionHeader
                                    eyebrow="Historique"
                                    title="Évolution de l'école"
                                    size="compact"
                                    align="start"
                                />

                            </section> */}

                            <section className="detail-section">
                                <PageSectionHeader
                                    eyebrow="Équipe"
                                    title="Responsable de l'aumônerie"
                                    size="compact"
                                    align="start"
                                />
                                <p className="detail-section__highlight">---</p>
                            </section>

                            <section className="detail-section">
                                <PageSectionHeader
                                    eyebrow="Contact"
                                    title="Contacts"
                                    size="compact"
                                    align="start"
                                />
                                <ul className="detail-section__list">
                                    <li><ContactLink value="---" /></li>
                                </ul>
                            </section>
                        </article>
                    </main>
                </div>
                <Hrseparator />
            </div>
        </>
    );
};
